export const AnimateIndicator = (() => {
	const setActiveItem = (item, indicator) => {
		if (item) {
			indicator.style.setProperty("transform", getTransform(item));
		}
	};

	/**
	 * @param {{currentTarget: HTMLElement}} e
	 */
	const onItemClick = (e, indicator) => {
		indicator.animate([{ transform: getTransform(e.currentTarget) }], {
			fill: "both",
			duration: 600,
			easing: "cubic-bezier(0.48, 1.15, 0.28, 1)",
		});

		setActiveItem(e.currentTarget, indicator);
	};

	/**
	 * @param {HTMLElement} element
	 * @return {string}
	 */
	const getTransform = (element) => {
		const transform = {
			x: element.offsetLeft,
			scaleX: element.offsetWidth / 100,
		};
		return `translateX(${transform.x}px) scaleX(${transform.scaleX})`;
	};

	const init = (indicatorCtn) => {
		const indicatorCtnItems = Array.from(indicatorCtn.querySelectorAll("button"));

		const indicator = document.createElement("span");
		indicator.classList.add("indicator");
		indicatorCtn.appendChild(indicator);

		let activeItem = indicatorCtn.querySelector("[aria-selected]");

		setActiveItem(activeItem, indicator);

		indicatorCtnItems.forEach((item) => {
			item.addEventListener("mouseover", (e) => {
				onItemClick(e, indicator);
			});
		});
	};

	const initAll = () => {
		document.querySelectorAll("[data-nav-indicator]").forEach((nav) => {
			AnimateIndicator.init(nav);
		});
	};

	return {
		init,
		initAll,
	};
})();
